/**
 * Licznik znakow pod polem tekstowym ("120 z 300 znaków"). Zwykly tekst pod polem: czytnik ekranu dostaje go przez
 * `aria-describedby` pola (id podaje wywolujacy), a nie przez aria-live, zeby nie czytac go po kazdym znaku (PR-5).
 */
export function LicznikZnakow({ id, dlugosc, max }: { id: string; dlugosc: number; max: number }): React.JSX.Element {
  return (
    <span className="trening-licznik" id={id}>
      {dlugosc} z {max} znaków
    </span>
  );
}
